import request from '@/utils/request';
import Resource from '@/api/resource';

class TitleResource extends Resource {
  constructor() {
    super('title');
  }

  // 删除标题库 */
  deleteApi(data) {
    return request({
      url: `${this.uri}/delete`,
      method: 'POST',
      data,
    });
  }

  // 获取标题库列表
  getApi(data) {
    return request({
      url: `${this.uri}`,
      method: 'GET',
      params: data,
    });
  }

  // 创建标题
  creatApi(data) {
    return request({
      url: `${this.uri}`,
      method: 'POST',
      data,
    });
  }

  // 批量创建标题
  batchCreatApi(data) {
    return request({
      url: `${this.uri}/batchAdd`,
      method: 'POST',
      data,
    });
  }

  // 修改标题
  editApi(data, id) {
    return request({
      url: `${this.uri}/${id}`,
      method: 'PUT',
      params: data,
    });
  }
}

export { TitleResource as default };
